import React from "react";
import { useNavigate } from "react-router-dom";
import { useLandingLang } from "../../i18n/LandingLangContext";

// --- ICONO SVG ---
function StethoscopeIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M4.8 2.3A.3.3 0 1 0 4.8.2c0 .1 0 .2.2.2h.7a1 1 0 0 1 1 1v3.4c0 .8.7 1.5 1.5 1.5h.6c.8 0 1.5-.7 1.5-1.5V1.4a1 1 0 0 1 1-1h.7c.2 0 .2-.1.2-.2a.3.3 0 1 0 0 .1v3.4a3.3 3.3 0 0 1-3.2 3.3H8a3.3 3.3 0 0 1-3.2-3.3V.2Z" />
    </svg>
  );
}

export function CtaBanner({ onOpenDemo }) {
  const { t } = useLandingLang();
  const navigate = useNavigate();
  return (
    <section className="py-32 px-6 bg-white border-t border-slate-200 text-center">
      <div className="max-w-5xl mx-auto text-center space-y-12 relative text-slate-700">
        {/* Fondo difuminado azul detrás del título */}
        <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-40 h-40 bg-blue-100 blur-3xl -z-10 opacity-50 text-center"></div>

        {/* Título Principal */}
        <h2 className="text-4xl md:text-6xl !font-black tracking-tight leading-none text-center">
          {t("ctaTitle1")}{" "}
          <span className="text-sky-500 italic text-center">
            {t("ctaTitle2")}
          </span>{" "}
          <br /> {t("ctaTitle3")}
        </h2>

        {/* Subtítulo */}
        <p className="text-xl text-slate-500 font-medium max-w-xl mx-auto leading-relaxed text-center">
          {t("ctaDesc")}
        </p>

        {/* Botones de acción */}
        <div className="flex flex-wrap justify-center gap-4 text-center">
          {/* Botón Primario */}
          <button
            onClick={onOpenDemo}
            className="px-10 py-5 bg-gradient-to-r from-sky-400 to-blue-500 text-white rounded-[2rem] !font-bold shadow-2xl hover:scale-105 active:scale-95 transition-all uppercase tracking-widest text-xs text-center border-0 cursor-pointer whitespace-nowrap"
          >
            {t("requestInfo")}
          </button>

          {/* Botón Secundario */}
          <button
            type="button"
            onClick={() => navigate("/auth")}
            className="px-10 py-5 bg-slate-100 border border-slate-200 text-slate-700 rounded-[2rem] !font-bold hover:bg-white transition-all flex items-center gap-2 uppercase tracking-widest text-xs text-center cursor-pointer whitespace-nowrap"
          >
            <StethoscopeIcon className="text-sky-500 w-5 h-5" />{" "}
            {t("proAccess")}
          </button>
        </div>
      </div>
    </section>
  );
}
